<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Upload Resume">
            <common-training-header/>
        </a-page-header>
        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :dataSource="tableData"
                rowKey="id"
                :loading="loading"
                :pagination="false"
                :rowClassName="(r) => r.is_heading ? 'row-heading' : null"
                bordered
                >

                <a-table-column key="title" title="Materi Pelatihan" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <template v-if="record.is_heading">
                            <strong>{{ record.name }}</strong>
                        </template>
                        <template v-else>
                            {{ record.name }}
                        </template>
                    </template>
                </a-table-column>

                <a-table-column key="inspirator" title="Inspirator" className="align-center text-small text-left">
                    <template slot-scope="record" v-if="! record.is_heading">
                        {{ record.inspirator }}
                    </template>
                </a-table-column>

                <a-table-column key="upload_date" title="Tanggal Upload" className="align-center text-small text-center">
                    <template slot-scope="record" v-if="! record.is_heading">
                        <template v-if="record.upload_date != null">
                            {{ moment(record.upload_date).format('DD-MM-YYYY HH:mm:ss') }}
                        </template>
                    </template>
                </a-table-column>

                <a-table-column key="last_upload_date" title="Tanggal Reupload" className="align-center text-small text-center">
                    <template slot-scope="record" v-if="! record.is_heading">
                        <template v-if="record.last_upload_date != null">
                            {{ moment(record.last_upload_date).format('DD-MM-YYYY HH:mm:ss') }}
                        </template>
                    </template>
                </a-table-column>

                <a-table-column key="file" title="File" className="align-center text-small text-center">
                    <template slot-scope="record" v-if="! record.is_heading">
                        <template v-if="record.attachment != null">
                            <a-button type="link" icon="video-camera" size="small" @click="download(record.attachment)">
                            Download
                            </a-button>

                            <a-tooltip title="Reupload resume">
                                <a-button type="dashed" icon="upload" size="small" @click="showModalResume(record.resume, true)"
                                v-if="record.locked == 0">
                                Reupload</a-button>
                            </a-tooltip>
                        </template>

                        <template v-else>
                            <a-button type="dashed" icon="upload" size="small"  @click="showModalResume(record.session, false)"
                                v-if="moment().diff(moment(record.time_end, 'YYYY-MM-DD HH:mm:ss'), 'minutes') > 0">
                                Upload
                            </a-button>
                        </template>
                    </template>
                </a-table-column>
            </a-table>
        </a-card>

        <a-modal
            :visible="visibleResume"
            :destroyOnClose="true"
            :footer="null"
            :closable="false"
        >
            <classical-upload-resume
                :session="session"
                :reupload="reupload"
                @handleClose="closeModal"
            />
        </a-modal>
    </div>
</template>

<script>
const materi = {
    id: 1,
    name: null,
    inspirator: null,
    is_heading: false,
    attachment: null,
    upload_date: null,
    last_upload_date: null,
    session: null,
    resume: null,
    time_end: null,
    locked: 0
}

export default {
    props: {
        training: {
            type: Object
        }
    },
    created() {
        this.getItems();
    },
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            visible: false,
            visibleResume: false,
            session: null,
            reupload: false,
            items: {},
        };
    },
    computed: {
        exportUri() {
            let params = {
                export: true,
                attempt_number: 1
            }

            return this.routeUri('general.exam.sessions.show', {
                class_session: this.class_session.id,
                exam_uuid: this.class_session.class_exam.exam_id
            }) + '?' + this.$qs.stringify(params)
        },
        tableData() {
            let collection = []
            let num = 1

            if(this.items.length > 0){
                this.items.forEach((item, index) => {
                    collection.push(Object.assign(Object.create(materi), {
                        id: num++,
                        name: item.name,
                        inspirator: null,
                        is_heading: true,
                        attachment: null,
                        upload_date: null,
                        last_upload_date: null,
                        sessions: null,
                        resume: null,
                        time_end: null,
                        locked: 0
                    }))

                    item.materials.forEach((item, index) => {
                        collection.push(Object.assign(Object.create(materi), {
                            id: num++,
                            name: item.name,
                            inspirator: item.sessions[0].inspirator.name,
                            is_heading: false,
                            attachment: item.sessions[0].resumes[0] ? item.sessions[0].resumes[0].attachment : null,
                            upload_date: item.sessions[0].resumes[0] ? item.sessions[0].resumes[0].upload_time : null,
                            last_upload_date: item.sessions[0].resumes[0] ? item.sessions[0].resumes[0].reupload_time : null,
                            session: item.sessions[0].id,
                            resume: item.sessions[0].resumes[0] ? item.sessions[0].resumes[0].id : null,
                            time_end: item.sessions[0].session_time_end,
                            locked: item.is_locked
                        }))
                    })
                })
            }

            return collection
        }
    },
    methods: {
        getItems() {
            let params = {
                xhr: true,
            }

            this.loading = true;
            this.$http
                .get(this.routeUri('api.classical-resumes.material.resumes') + '?' + this.$qs.stringify(params))
                .then(response => {
                    this.items = response.data.material_resumes.categories
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        download(url) {
            window.open(url, '_blank')
        },
        closeModal(isRefresh) {
            this.visibleResume = false;

            if (isRefresh == true) {
                this.getItems();
            }
        },
        showModalResume(session, reupload) {
            this.session = session.toString();
            this.reupload = reupload
            this.visibleResume = true;
        },
    }
};
</script>


